export enum INPUT_VALUE {
    OTHER = 'Other',
}

export const otherValue = 'other'
